<template>
    <div class="top-ranking-item" :class="[variantClass, { 'is-placeholder': !user }]">
        <div class="avatar-wrap" :class="sizeClass" v-if="user">
            <div class="light-avatar"></div>
            <img class="avatar-bg" :class="position === 1 ? 'top-ranking-big' : 'top-ranking-small'" src="/media/svg/rounded-avatar.svg" alt="avatar-bg"/>
            <img class="avatar" :src="user?.avatar ?? '/media/default-avatar.png'" @error="e => e.target.src = '/media/default-avatar.png'" alt="">
        </div>
        <div class="info">
            <div class="rank-small gradient-text" v-if="user.name">{{ user ? `0${displayRank}` : '--' }}</div>
            <div style="display: flex; flex-direction: column; justify-content: start;">
                <div class="name gradient-text">
                    {{ user ? user?.name : 'Đang cập nhật' }}
                </div>
                <div class="subtitle" v-if="user && user?.department">{{ user?.department }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TopRanking',
    props: {
        user: {
            type: Object,
        },
        position: {
            type: Number,
            default: 2
        },
        maxScore: {
            type: Number,
            default: 700
        },
    },
    data() {
        return {
            isTablet: window.innerWidth <= 1024,
            sizeClass: 'top-ranking-big',
        }
    },
    computed: {
        variantClass() {
            if (this.position === 1) return 'top-1';
            if (this.position === 2) return 'top-2';
            return 'top-3';
        },
        displayRank() {
            return this.user.rank || this.position;
        },
    },
    methods: {
        getSizeClass() {
            this.sizeClass = this.position === 1 ? 'top-ranking-big' : 'top-ranking-small'
        },
    },
    created() {
        this.getSizeClass()
    }
}
</script>

<style scoped>
.top-ranking-item {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
}

.avatar-wrap {
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.top-ranking-small {
    width: 200px;
    height: 200px;
}

.top-ranking-big {
    width: 250px;
    height: 250px;
}

.avatar-bg {
    position: absolute;
    top: 0; left: 0; bottom: 0; right: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
    z-index: 1;
    pointer-events: none;
}

.avatar {
    position: absolute;
    top: 14px; left: 16px;
    width: 85%;
    height: 85%;
    object-fit: cover;
    border-radius: 50%;
    z-index: 0;
    padding: 4px;
}

.info {
    display: flex;
    align-items: center;
    margin-top: 6px;
    z-index: 5;
}

.rank-small {
    font-weight: 700;
    font-size: 50px;
    padding-right: 12px;
}

.name {
    font-style: italic;
    font-weight: 700;
    font-size: 24px;
    white-space: nowrap;
    padding-right: 5px;
}

.subtitle {
    font-size: 11px;
    font-style: italic;
    margin-bottom: 5px;
    line-height: 12px;
}

.top-1 .rank-small {
    font-size: 65px;
    margin-right: -8px;
}
.top-1 .name { font-size: 32px; padding-right: 10px}
.top-1 .subtitle { font-size: 13px; line-height: 14px; margin-bottom: 10px}

.top-2 .big-rank, .top-3 .big-rank {
    font-size: 100px;
    right: 6%;
    top: 10px;
}

.top-1 .light-avatar {
    left: 45px;
}

.light-avatar {
    position: absolute;
    top: 40px; left: 30px;
    width: 4px;
    z-index: 100;
    height: 4px;
    border-radius: 50%;
    box-shadow: 0 0 25px 25px rgba(206, 159, 56, 100);
    background: radial-gradient(circle, #E5C769 0%, #E5C769 100%);
}

@media (max-width: 1024px) {
    .top-ranking-item { width: 180px; }
    .top-ranking-item .big-rank { font-size: 78px; }
    .top-1 { width: 200px; }
    .top-ranking-small {
        width: 120px;
        height: 130px;
    }

    .top-ranking-big {
        width: 170px;
        height: 190px;
    }

    .name {
        font-size: 13px;
    }

    .top-1 .name { font-size: 22px; margin-top: -3px}

    .rank-small {
        font-size: 35px;
    }

    .top-1 .rank-small {
        font-size: 55px;
    }
    .subtitle {
        font-size: 8px;
    }

    .top-1 .subtitle {
        font-size: 12px;
    }
}
.gradient-text {
    font-style: italic;
    font-weight: bold;
    background: linear-gradient(to bottom right, #6D3C09 0%, #FAEB95 24%, #E5C769 32%, #D4AA45 40%, #CA982F 47%, #C79228 51%, #C8952C 55%, #CE9F38 59%, #D8B04C 64%, #D8B04C 68%, #F6E58E 72%, #FAEB95 73%, #6D3C09 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;
}

@media (max-width: 767px) {
    .name {
        font-size: 16px;
    }

    .top-1 .name { font-size: 24px; margin-top: 0}

    .rank-small {
        font-size: 40px;
    }

    .top-1 .rank-small {
        font-size: 60px;
    }
    .subtitle {
        font-size: 12px;
    }

    .top-1 .subtitle {
        font-size: 16px;
    }
    .top-ranking-item { width: 100% }
}

</style>
